var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 302,
    height: 302,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(4, 6, 9)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 15,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.125s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 15,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.25s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 39,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.875s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 39,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.375s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 63,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.75s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 63,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.625s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 63,
    width: 22,
    height: 22,
    fill: "#353537"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1f316a;#353537;#353537",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLoading);
export default __webpack_public_path__ + "static/media/selectLoading.474654bb6fbaace52944f860731df037.svg";
export { ForwardRef as ReactComponent };